import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { NavLink, Link, useLocation } from "react-router-dom"; // <-- add useLocation here
import Logo from "../../assets/logo.jpg";
import "./HomeNavbar.css";

const HomeNavbar = () => {
  const location = useLocation();

  // Determine if current path is homepage
  const isHomePage = location.pathname === "/";

  return (
    <Navbar expand="md" className="home-navbar">
      <Container fluid className="navbar-container">
        {/* Conditionally render the logo only if NOT on homepage */}
        {!isHomePage && (
          <Navbar.Brand as={Link} to="/" className="navbar-logo">
            <img src={Logo} alt="Blukraft company logo" />
          </Navbar.Brand>
        )}

        {/* Schedule button for mobile view */}
        <div className="schedule-mobile d-md-none">
          <button className="schedule-button">
            <Nav.Link as={NavLink} to="/schedulemetting">Connect</Nav.Link>
          </button>
        </div>

        {/* Hamburger toggle */}
        <Navbar.Toggle aria-controls="navbarScroll" className="navbar-toggler" />

        {/* Collapsible nav */}
        <Navbar.Collapse id="navbarScroll" className="navbar-collapse">
          <Nav className="navbar-links" navbarScroll>
            <Nav.Link as={NavLink} to="/" end>Home</Nav.Link>
            <Nav.Link as={NavLink} to="/about">About Us</Nav.Link>
            <Nav.Link as={NavLink} to="/offerings">Offerings</Nav.Link>

            <NavDropdown title="Our Company" id="navbarScrollingDropdown">
              <NavDropdown.Item as={NavLink} to="/leadership">Leadership</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/newsandevents">News &amp; Events</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/culture">Culture</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/career">Careers</NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={NavLink} to="/contactus">Contact Us</Nav.Link>

            {/* Schedule button for desktop view */}
            <div className="schedule-desktop d-none d-md-block">
              <button className="schedule-button">
                <Nav.Link as={NavLink} to="/schedulemetting">Connect with Us</Nav.Link>
              </button>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default HomeNavbar;
